import { Skeleton } from 'antd';
import React from 'react';

interface Props {
  isLoading?: boolean;
  children?: JSX.Element | string;
}

export const ProspectDataSkeleton: React.FC<Props> = (props: Props) => {
  const { isLoading, children } = props;

  const attrs = {
    wrapper: { className: 'prospect' },
    header: { className: 'prospect__header' },
    bodyWrapper: {
      wrapper: { className: 'prospect__body' },
      row: { className: 'prospect__body__row' },
      rowlabel: { className: 'prospect__body__row-label' },
      rowvalue: { className: 'prospect__body__row-value' },
      divider: { className: 'prospect__body-divider', style: { width: '95%' } },
      contact: {
        wrapper: {
          className: 'prospect__body__contact__data',
        },
        avatarWrapper: {
          className: 'prospect__body__contact__data-avatar',
        },
        rowName: {
          className: 'prospect__body__contact__data-info-name',
        },
        infoWrapper: {
          className: 'prospect__body__contact__data-info',
        },
        info: {
          className: 'prospect__body__contact__data-info-other',
        },
      },
    },
    skeletons: {
      header: {
        loading: isLoading,
        active: true,
        avatar: false,
        paragraph: false,
        title: {
          style: {
            width: 95,
            maxWidth: '100%',
            height: 15,
            borderRadius: 2,
            marginTop: 2,
          },
        },
      },
      label: {
        loading: isLoading,
        active: true,
        avatar: false,
        paragraph: false,
      },
      value: {
        loading: isLoading,
        active: true,
        avatar: false,
        paragraph: false,
      },
      prospectInfo: {
        loading: isLoading,
        active: true,
        avatar: false,
        paragraph: false,
        title: {
          style: {
            width: 130,
            maxWidth: '100%',
            height: 12,
            borderRadius: 2,
            marginTop: 8,
          },
        },
      },
      name: {
        loading: isLoading,
        active: true,
        avatar: false,
        paragraph: false,
        title: {
          style: {
            width: 95,
            maxWidth: '100%',
            height: 12,
            borderRadius: 2,
            marginTop: -5,
          },
        },
      },
    },
  };

  const setCompanyRow = (labelWidth: string, valueWidth: string) => {
    return (
      <div {...attrs.bodyWrapper.row}>
        <div {...attrs.bodyWrapper.rowlabel}>
          <Skeleton
            {...attrs.skeletons.label}
            title={{
              style: {
                width: labelWidth,
                height: 12,
                borderRadius: 2,
                marginTop: -2,
              },
            }}
          />
        </div>
        <div {...attrs.bodyWrapper.rowvalue}>
          <Skeleton
            {...attrs.skeletons.value}
            title={{
              style: {
                width: valueWidth,
                height: 12,
                borderRadius: 2,
                marginTop: -2,
              },
            }}
          />
        </div>
      </div>
    );
  };

  const socialMediaRow = () => {
    const iconSkeleton = (
      <Skeleton
        {...attrs.skeletons.value}
        title={{
          style: {
            width: 18,
            height: 18,
            borderRadius: '50%',
            marginTop: -2,
            marginRight: 15,
          },
        }}
      />
    );
    return (
      <div {...attrs.bodyWrapper.row}>
        <div {...attrs.bodyWrapper.rowlabel}>
          <Skeleton
            {...attrs.skeletons.label}
            title={{
              style: {
                width: 70,
                height: 12,
                borderRadius: 2,
                marginTop: -2,
              },
            }}
          />
        </div>
        <div {...attrs.bodyWrapper.rowvalue} style={{ width: '100px' }}>
          {iconSkeleton}
          {iconSkeleton}
          {iconSkeleton}
        </div>
      </div>
    );
  };

  const companyRows = (
    <>
      {setCompanyRow('50px', '60%')}
      {setCompanyRow('20px', '65%')}
      {setCompanyRow('70px', '40%')}
      {setCompanyRow('50px', '90%')}
      {setCompanyRow('50px', '45%')}
      {setCompanyRow('70px', '30%')}
      {setCompanyRow('70px', '15%')}
      {setCompanyRow('70px', '35%')}
      {setCompanyRow('65px', '40%')}
      {socialMediaRow()}
    </>
  );

  const nameRowSkeleton = (
    <div {...attrs.bodyWrapper.contact.rowName}>
      <Skeleton {...attrs.skeletons.name} />
      <Skeleton
        {...attrs.skeletons.value}
        title={{
          style: {
            width: 18,
            height: 18,
            borderRadius: '50%',
            marginTop: -2,
            marginLeft: 15,
          },
        }}
      />
    </div>
  );

  return (
    <>
      {isLoading ? (
        <div {...attrs.wrapper}>
          <div {...attrs.header}>
            <Skeleton {...attrs.skeletons.header} />
          </div>
          <div {...attrs.bodyWrapper}>
            {companyRows} <div {...attrs.bodyWrapper.divider} />{' '}
            <div {...attrs.bodyWrapper.contact.wrapper}>
              <div {...attrs.bodyWrapper.contact.avatarWrapper}>
                <Skeleton
                  loading={isLoading}
                  active
                  avatar={{ size: 50 }}
                  paragraph={false}
                  title={false}
                />
              </div>
              <div {...attrs.bodyWrapper.contact.infoWrapper}>
                <div {...attrs.bodyWrapper.contact.info}>
                  {nameRowSkeleton}
                  <Skeleton {...attrs.skeletons.prospectInfo} />
                  <Skeleton {...attrs.skeletons.prospectInfo} />
                  <Skeleton {...attrs.skeletons.prospectInfo} />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        children
      )}
    </>
  );
};
